import { User } from 'config/api';

type ParamsProps = { dsi: string };
// urlパラメータ取得
export function urlParams(params: ParamsProps): ParamsProps {
  const urlParamStr = window.location.search.substring(1);
  urlParamStr.split('&').forEach(param => {
    const temp = param.split('=');
    //pramsオブジェクトにパラメータを追加
    params = {
      ...params,
      [temp[0]]: temp[1],
    };
  });
  return params;
}

/*
  HACK:
    SessionStorageからの脱却を考える(以下4つのメソッドを廃止する)
    Context使って、AppからUser情報を流すか
 */
export const getUserStorage = (): User | null => {
  const userJson = sessionStorage.getItem('user');
  return userJson ? (JSON.parse(userJson) as User) : null;
};
export const isFirstTimeLogin = (): boolean => {
  const user = getUserStorage();
  return user
    ? user.LastLoginDateTime === null || user.LastLoginDateTime === undefined
    : false;
};
export const setLastLoginDateTime = (): void => {
  const user = getUserStorage();
  if (user) {
    user.LastLoginDateTime = new Date().toLocaleString();
    sessionStorage.setItem('user', JSON.stringify(user));
  }
};

export const groupBy = <K, V>(
  array: readonly V[],
  getKey: (cur: V, idx: number, src: readonly V[]) => K
): [K, V[]][] =>
  Array.from(
    array.reduce((map, cur, idx, src) => {
      const key = getKey(cur, idx, src);
      const list = map.get(key);
      if (list) list.push(cur);
      else map.set(key, [cur]);
      return map;
    }, new Map<K, V[]>())
  );
